needsHashChangeListener